export class SmsSetup {
    appId: string;
    authKey: string;
    clientId: string;
    gatewayName: string;
    password: string;
    senderId: string;
    smsSetupId: number;
    userName: string;
}